import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

interface UseUnassignUserProps {
    orgId: string;
    dealId: number;
    timelineId: number;
}

const unassignUserFromTimeline = async (
    orgId: string,
    dealId: number,
    timelineId: number,
    userCorrelationId: string,
): Promise<void> => {
    await axiosInstance.delete(
        API_ENDPOINTS.TIMELINE_ASSIGNEE_BY_USER(orgId, dealId, timelineId, userCorrelationId),
    );
};

export const useUnassignUser = ({ orgId, dealId, timelineId }: UseUnassignUserProps) => useMutation({
    mutationFn: (userCorrelationId: string) =>
        unassignUserFromTimeline(orgId, dealId, timelineId, userCorrelationId),
});
